<div class="fulfillmentLanding xs-mt-0 xs-mb-20">
  <div class="status-bar">
    <div><span class="font16 pr-2">Status Notice:</span><span>{{bannerMessage}}</span></div>
  </div>
</div>

<div class="fulfillmentLanding seed-return-wrapper">
  <div class="cppReturnsLandingPage">
    <div class="row">
      <div class="col-md-10 col-lg-10 margin-l0 TopSec">
        <h3>
          Seed Replant
        </h3>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-11 col-md-9 pr-0">
        <app-filter [(optionsData)]="filterOptionsData" [isSearchButtonOutside]="true" (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)"></app-filter>
      </div>
      <div class="col-lg-1 col-md-3 margin-t12 text-left">
        <button mat-raised-button class="btns xs-button xs-full-width export-button" [disabled]="(this.selectedTabIndex === 0 && this.returnRequestList && this.returnRequestList.length <= 0) || (this.selectedTabIndex === 1 && this.returnRequestDraftList && this.returnRequestDraftList.length <= 0)" (click)="export()">Export</button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 legend-outer">
        <div class="legendBlock">
          <ul>
            <li class="yellow">NEW COMMENTS </li>
            <li class="red">THERE ARE ERRORS IN THE ORDER</li>
          </ul>
        </div>
        <mat-tab-group disableRipple [animationDuration]="'400ms'" class="matTabs prepayLandingTab" (selectedTabChange)="tabChanged($event)">

          <mat-tab>
            <ng-template mat-tab-label>
              <i class="icon-ico-dealer_icon xs-mr-5" aria-hidden="true"></i>
              <div class="tab-head" id="activeTab">
                <h4>
                  Active Replant Requests
                </h4>
                <p class="subhead">
                  Add/Manage products for replant.
                </p>
              </div>
            </ng-template>
            <div class="fulfill-top-sec">
              <div class="row listing-action-items">
                <div class="col-sm-4">
                </div>
                <div class="col-xl-8 col-lg-8 col-md-8 text-right">
                  <div class="display-ib wAuto">
                    <mat-paginator #returnRequestPaginator [pageSize]="masterConstants.PAGE_SIZE" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
                  </div>
                  <!--<button *ngIf="!readOnlyAccess && isShowCreateNewRequestByConfigData" mat-raised-button class="btns margin-l5 index-z200" color="primary" (click)="createNewReplantRequest()" data-testid="btn-create-new-request">Create New Request</button>-->
                  <button *ngIf="!readOnlyAccess" mat-raised-button class="btns margin-l5 index-z200" color="primary" [disabled] = "!enableExportExcelButton" (click)="exportToExcel()" data-testid="btn-create-new-request">Export to Excel</button>
                  <button *ngIf="!readOnlyAccess" mat-raised-button class="btns margin-l5 index-z200" color="primary" (click)="createNewReplantRequest()" data-testid="btn-create-new-request">Create New Request</button>
                </div>
              </div>
            </div>

            <div class="tableContainer activeReturnRequest">
              <table mat-table #returnRequestTable [dataSource]="returnRequestDataSource" matSort #returnRequestSort matSortDirection="desc" class="matTables seedLossDraftTable ">
                <ng-container matColumnDef="checkbox">
                  <th mat-header-cell *matHeaderCellDef class="text-left">
                    <mat-checkbox *ngIf="!disablecheckboxReplant && !readOnlyAccess"
                                  #AllProductCheck
                                  class="custom-checkbox select-all-check"
                                  [checked]="isAllReplantProductChecked"
                                  [indeterminate]="checkBoxCount > 0 && !isAllReplantProductChecked"
                                  (change)="enableAllCheckBoxes(!isAllReplantProductChecked)"
                                  title="Select All Lines"
                                  aria-label="Select All Lines">
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    <div class="order-info">
                      <mat-checkbox *ngIf="!readOnlyAccess"
                                    #SingleCheck
                                    [(ngModel)]="element.isSelected"
                                    (change)="enableCheckBoxSingle(SingleCheck._checked)"
                                    class="custom-checkbox">
                      </mat-checkbox>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="webOrderNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Request Id</th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    <div class="order-info" (click)="navigateViewRequest(element)">
                      <u>
                        <p class="font14 handCursor">
                          {{element.webOrderNumber}}
                        </p>
                      </u>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="custPONumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="customerPO text-center">Customer PO</th>
                  <td mat-cell *matCellDef="let element" class="ml-0 text-center">
                    <div class="order-info">
                      <p class="grower-name">
                        {{element.custPONumber}}
                      </p>
                      <p></p>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="accountName">
                  me
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center pl-3">Account Name </th>
                  <td mat-cell *matCellDef="let element">
                    <div class="order-info defaultCursor">
                      <p class="grower-name">
                        {{element.accountName}}
                      </p>
                      <p class="font14">{{element.accountAddress1 || element.accountAddress2}}, {{element.accountCity}}, {{element.accountState}} {{element.accountZipCode}}</p>
                    </div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>  </td>
                </ng-container>
                <ng-container matColumnDef="accountNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo  text-center">Account Number</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{element.accountNumber}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="requestDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate  text-center">Request Date</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{element.requestDate | date: masterConstants.DATE_MMDDYYYY}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="replantProducts">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo  text-center">Replant Products</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{element.replantProducts}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="units">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="units  text-center">Units</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{element.units}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="status text-center">Status</th>
                  <td mat-cell *matCellDef="let element" class="text-center statusUppercase">
                    {{element.status}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="viewOrder">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="actionBtn  text-center"></th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    <div>
                      <button mat-button [matMenuTriggerFor]="beforeMenu1" class="context-menu">
                        <i class="fas fa-ellipsis-v blue-color"></i>
                      </button>
                      <mat-menu #beforeMenu1="matMenu" xPosition="before" class="context-meun-dropdown">
                        <!--<button mat-menu-item
                        *ngIf="isApprovalAccess && element.isDSM"
                        (click)="navigateApproveRequest(element)">Approve Request</button>-->
                        <button mat-menu-item *ngIf="element.jdeOrderNumber && element.jdeOrderType" (click)="viewOrderToInvoice(element)">View Order</button>
                        <button mat-menu-item (click)="emailOrderDetail(element)">Email Request</button>
                        <button mat-menu-item (click)="generatedPdf(element)">Download PDF</button>
                      </mat-menu>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="returnRequestColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let row; columns: returnRequestColumns;"></tr>
              </table>
              <div *ngIf="returnRequestList == undefined || returnRequestList.length == 0" class="noDataMsg">
                <p class="padding-b47">No Record Found.</p>
              </div>
            </div>
          </mat-tab>

          <mat-tab>
            <div class="col-md-2">
              <ng-template mat-tab-label>
                <i class="icon-ico-grower_icon xs-mr-5" aria-hidden="true"></i>
                <div class="tab-head" id="draftTab">
                  <h4>
                    Replant Request Drafts
                  </h4>
                  <p class="subhead">
                    Finish your draft to submit the request.
                  </p>
                </div>
              </ng-template>
            </div>
            <div class="fulfill-top-sec">
              <div class="row listing-action-items">
                <div class="col-xl-4 col-lg-4 col-md-3 smallPadRgt0">
                </div>
                <div class="col-xl-8 col-lg-8 col-md-8 text-right">
                  <div class="display-ib wAuto">
                    <mat-paginator #returnRequestDraftPaginator [pageSize]="masterConstants.PAGE_SIZE" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
                  </div>
                </div>
              </div>
            </div>
            <div class="tableContainer draftReturnRequest">
              <table mat-table #returnRequestDraftTable [dataSource]="draftRequestDataSource" matSort #returnRequestDraftSort matSortDirection="desc" class="matTables seedLossDraftTable">
                <ng-container matColumnDef="webOrderNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Request Id</th>
                  <td mat-cell *matCellDef="let element" class="text-left">
                    <div class="order-info " (click)="navigateReplantRequestDetail(element)">
                      <u>
                        <p class="font14 handCursor">
                          {{element.webOrderNumber}}
                        </p>
                      </u>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="custPONumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="customerPO text-center">Customer PO</th>
                  <td mat-cell *matCellDef="let element" class="ml-0 text-center">
                    <div class="order-info cursor-default-pointer">
                      <p class="grower-name">
                        {{element.custPONumber}}
                      </p>
                      <p></p>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="accountName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="return-request text-center pl-3">Account Name</th>
                  <td mat-cell *matCellDef="let element" class="ml-0">
                    <div class="order-info cursor-default-pointer">
                      <p class="grower-name">
                        {{element.accountName}}
                      </p>
                      <p class="font14">{{element.accountAddress1 || element.accountAddress2}}, {{element.accountCity}}, {{element.accountState}} {{element.accountZipCode}}</p>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="accountNumber">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo text-center">Account Number</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{element.accountNumber}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="draftDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate  text-center">Draft Date</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{element.draftDate | date: masterConstants.DATE_MMDDYYYY}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="replantProducts">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="dsmNo  text-center">Replant Products</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{element.replantProducts}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="units">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="units  text-center">Units</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{element.units}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="status text-center">Status</th>
                  <td mat-cell *matCellDef="let element" class="text-center statusUppercase">
                    {{element.status}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="deleteRequest">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate  text-center">Delete Request</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <i title="delete" class="icon-ico-trash handCursor" (click)="deletedraftrequest(element)"></i>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="returnRequestDraftColumns;"></tr>
                <tr mat-row *matRowDef="let row; columns: returnRequestDraftColumns;"></tr>
              </table>
              <div *ngIf="returnRequestDraftList == undefined || returnRequestDraftList.length == 0" class="noDataMsg">
                <p class="padding-b47">No Record Found.</p>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>
